// Suffix after a rent price: "/ місяць" for long-term rent, "/ доба" for
// daily and "/ година" for hourly. A sale or an auction has no period.
// The listing page used to say "/ місяць" for every rent type, and the
// modal even for sales.
const PERIOD_KEY_BY_LISTING_TYPE: Record<string, string> = {
  RENT_LONG_TERM: 'announcement.per_month',
  RENT_DAILY: 'announcement.per_day',
  RENT_HOURLY: 'announcement.per_hour',
}

export const pricePeriodKey = (listingType?: string | null): string | null =>
  (listingType && PERIOD_KEY_BY_LISTING_TYPE[listingType.toUpperCase()]) || null
